import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { GridFilter, PagingDataResult, isNumber } from "projects/sepidz-web-framework/src/lib/services";
import { BehaviorSubject, Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Goods } from "../../models/goods.model";
import { Warehouse } from "../../models/warehouse.model";

@Component({
  selector: "ngx-warehouse-form",
  templateUrl: "./warehouse-form.component.html",
  styleUrls: ["./warehouse-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseFormComponent extends BaseFormComponent<Warehouse> {
  WarehouseGoodsColumn: form_control[] = [];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.onDataStateChange = this.onDataStateChange.bind(this);
  }
  async ngOnInit() {
    this.apiName = "Warehouse";
    this.label = this.translate("ClientApp.BackOffice.INV.Warehouse.Warehouse");
    super.ngOnInit();
  }
  getFilters(columnsName: string, searchValue: string, skip: number, take: number) {
    var filters: GridFilter[] = [];
    const columns = columnsName.split(",");
    columns.forEach((x) => {
      {
        if (x !== "Id")
          filters.push({ Filed: x, Operator: "contains", Type: "F", Skip: skip, Take: take, Value: searchValue.toString(), Logic: "or" });
        else if (isNumber(searchValue))
          filters.push({ Filed: x, Operator: "eq", Type: "F", Skip: skip, Take: take, Value: Number(searchValue), Logic: "or" });
      }
    });
    return filters;
  }
  onDataStateChange(columnName: string, searchValue: string, skip: number, take: number): Observable<PagingDataResult<Goods>> {
    var abs = new BehaviorSubject<PagingDataResult<Goods>>(undefined);
    const goodsIds: number[] = [];
    if (columnName === "GoodsId") {
      this.model.WarehouseGoodss.forEach((x) => {
        if (x.State !== RowState.Delete && x.State !== RowState.Detached) goodsIds.push(x.GoodsId);
      });
    }
    let apiName: string = "Goods/GetGoodsByGoodsId";
    const filter = this.getFilters("Id,Code,Title", searchValue, skip, take);
    if (goodsIds && goodsIds.length > 0)
      filter.push({ Filed: "goodsIds", Operator: "eq", Value: goodsIds, Type: "F", Skip: skip, Take: take, Logic: "and" });
    this.httpCommonService
      .GetFilterGrid<PagingDataResult<Goods>>(apiName, filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: PagingDataResult<Goods>) => {
        if (x) abs.next(x);
      });
    return abs.asObservable();
  }
  setdefault() {
    this.selectorService.setDataStateChange("GoodsId", this.onDataStateChange);
    if (!this.model.WarehouseGoodss) this.model.WarehouseGoodss = [];

    if (!this.model.Quarantine) {
      this.model.Quarantine = false;
      if (this.formGroup) this.formGroup.controls["Quarantine"].setValue(this.model.Quarantine);
    }
    super.setdefault();
  }
  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.setGoodsColumn();
  }
  setGoodsColumn() {
    this.selectorService.setTakeValue("GoodsId", 1000);
    let c = this.getDetailControlModels("WarehouseGoodss");
    c.forEach((x) => {
      if (x.name === "GoodsId") x.isMulti = true;
    });
    this.WarehouseGoodsColumn = c;
  }
  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (!this.model) this.model = <Warehouse>{};
        if (data) {
          this.model["Code"] = data as number;
        }
        this.setdefault();
      });
  }
  valueChanges($event) {}
  beforupdate() {
    this.model.WarehouseGoodss.forEach((x) => {
      if (!x.WarehouseId) x.WarehouseId = this.model.Id;
    });
  }
}
